import { createSelector } from "reselect";

const selectSignIn = (state) => state.signIn;

export const selectLoginStatus = createSelector([selectSignIn], (signIn) => {
  return {
    success: signIn.loginSuccess,
    loading: signIn.loading,
    error: signIn.errorMessage,
  };
});
